import React, { useEffect, useState, FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import firebase from "firebase/compat/app";
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import * as yup from 'yup';

//Services
import { getCycleById, createCycle, updateCycle } from '../../services/CycleService';
// import { getGroupsWithoutCycle, updateGroupsCycle } from '../../services/GroupService';

//Components
import { Button, Container, Form, Row } from 'react-bootstrap';
// import ActivityDualList from '../common/ActivityDualList';
import ActivityLoading from '../common/ActivityLoading';
import ActivityToast from '../common/ActivityToast';

//Types
import { CycleInterface, /* GroupInterface, */ ToastOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

const schema = yup.object().shape({
    name: yup.string().required("El campo 'Nombre' es requerido"),
    start_date: yup.string().required("El campo 'Fecha inicial' es requerido"),
    end_date: yup.string().required("El campo 'Fecha final' es requerido")
});

const defaultValues: any = {
    name: "",
    start_date: undefined,
    end_date: undefined,
    groups: []
};

// interface GroupListInterface {
//     available: Array<GroupInterface>,
//     selected: Array<GroupInterface>
// }

const NewCycle: FC = (props: any) => {
    const { location } = props;

    const [action, setAction] = useState("create");
    const [loading, setLoading] = useState(false);
    const [cycle, setCycle] = useState<CycleInterface | undefined>(undefined);
    // const [groupList, setGroupList] = useState<GroupListInterface>({ available: [], selected: [] });
    // const [groupsNoCycle, setGroupsNoCycle] = useState<Array<GroupInterface> | undefined>(undefined);
    // const [groupsByCycle, setGroupsByCycle] = useState<Array<GroupInterface> | undefined>(undefined);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();

    const { control, setValue, formState, handleSubmit } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });
    const { errors } = formState;

    useEffect(() => {
        setLoading(true);

        const locationSplit = location.pathname.split('/')
        if (locationSplit[2] === "edit") {
            setAction("update")
            fetchCycle(locationSplit[3]);
        } else {
            setCycle({} as CycleInterface);
        }

        // getGroupsWithoutCycle().then((response: any) => {
        //     setGroupsNoCycle(response as Array<GroupInterface>);
        // })
    }, [location])

    useEffect(() => {
        if (cycle) {
            // if (cycle.groups) {
            //     setGroupsByCycle(cycle.groups);
            // } else {
            //     setGroupsByCycle([]);
            // }

            setValue('name', cycle.name ? cycle.name : "");
            setValue('start_date', cycle.start_date ? moment(cycle.start_date.toDate()).format("YYYY-MM-DD") : undefined);
            setValue('end_date', cycle.end_date ? moment(cycle.end_date.toDate()).format("YYYY-MM-DD") : undefined);
            setLoading(false)
        }
    }, [cycle, setValue])

    // useEffect(() => {
    //     if (groupsByCycle && groupsNoCycle) {
    //         const selected: Array<GroupInterface> = [];
    //         const available: Array<GroupInterface> = [];

    //         groupsByCycle.forEach(gByCycle => {
    //             selected.push({ id: gByCycle.id, name: gByCycle.name })
    //         });

    //         groupsNoCycle.forEach(gNoCycle => {
    //             available.push({ id: gNoCycle.id, name: gNoCycle.name })
    //         });

    //         setGroupList({ selected, available } as GroupListInterface);
    //         setLoading(false)
    //     }
    // }, [groupsByCycle, groupsNoCycle])

    const onSubmit = (cycleData: CycleInterface) => {
        setLoading(true)

        const startDateMoment = moment(cycleData.start_date);
        const startDate = firebase.firestore.Timestamp.fromDate(startDateMoment.toDate());

        const endDateMoment = moment(cycleData.end_date);
        const endDate = firebase.firestore.Timestamp.fromDate(endDateMoment.toDate());

        const payload: CycleInterface = {
            name: cycleData.name,
            start_date: startDate,
            end_date: endDate,
            // groups: groupList.selected,
            deleted: false
        }

        if (action === "update" && cycle) {
            updateCycle(cycle.id, payload)
                .then((response: string) => {
                    if (response !== "error") {
                        history.push({ pathname: `/cycles` })
                        // updateGroups(cycle.id, cycleData.name);
                    } else {
                        setToastOptions({ open: true, message: "Ha ocurrido un error" })
                        setLoading(false)
                    }
                });
        } else {
            createCycle(payload).then((response: string) => {
                if (response !== "error") {
                    history.push({ pathname: `/cycles` })
                    // updateGroups(response, cycleData.name);
                } else {
                    setToastOptions({ open: true, message: "Ha ocurrido un error" })
                    setLoading(false)
                }
            });
        }
    }

    const fetchCycle = (cycleId: string) => {
        if (!cycleId || cycleId === "error") {
            setToastOptions({ open: true, message: "Ha ocurrido un error" })
            setLoading(false)
            return;
        }

        getCycleById(cycleId).then((response: any) => {
            setCycle(response as CycleInterface)
        })
    }

    // const updateGroups = (cycleId: any, cycleName: string) => {
    //     const removeGroupsCycle = groupsByCycle ?
    //         groupList.available.filter((ele: GroupInterface) => {
    //             return groupsByCycle.find((ubg: GroupInterface) => ubg.id === ele.id);
    //         }) :
    //         groupList.available.filter((ele: GroupInterface) => ele.id);

    //     const addGroupsCycle = groupList.selected.filter((ele: GroupInterface) => ele.id);

    //     updateGroupsCycle(cycleId, cycleName, removeGroupsCycle, addGroupsCycle)
    //         .then((response: any) => {
    //             if (response !== "error") {
    //                 history.push({ pathname: `/cycles` })
    //             } else {
    //                 setToastOptions({ open: true, message: "Ha ocurrido un error" })
    //                 setLoading(false)
    //             }
    //         });
    // }

    // const handleDualSave = (data: any) => {
    //     setGroupList(data);
    // }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    if (loading) {
        return <ActivityLoading />
    }

    return (
        <Container>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <div style={{ marginBottom: '10px' }}>
                <h1>Ciclo escolar</h1>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => history.goBack()}
            >
                {`Regresar`}
            </Button>
            <form className="flex flex-col justify-center w-full" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <Form.Group controlId="cycleName">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                {...field}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.name?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                />
                <Row xs={1} md={2}>
                    <Controller
                        name="start_date"
                        control={control}
                        render={({ field }) => (
                            <Form.Group controlId="cycleName">
                                <Form.Label>Fecha inicial</Form.Label>
                                <Form.Control
                                    {...field}
                                    type="date"
                                    isInvalid={!!errors.start_date}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.start_date?.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}
                    />

                    <Controller
                        name="end_date"
                        control={control}
                        render={({ field }) => (
                            <Form.Group controlId="cycleName">
                                <Form.Label>Fecha final</Form.Label>
                                <Form.Control
                                    {...field}
                                    type="date"
                                    isInvalid={!!errors.end_date}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.end_date?.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        )}
                    />
                </Row>
                <Button
                    type="submit"
                    variant="primary"
                    aria-label="save"
                >
                    {`Guardar ciclo`}
                </Button>
            </form>
        </Container>
    )
}

export default NewCycle;
